import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Grid, Theme } from '@mui/material';
import { PoolTextField, PoolTypography } from '@synergy/components';
import { getSuffixCurrency } from '@synergy/utils';
import { makeStyles } from '@mui/styles';

import { CurrencyPriceFormValues } from '../models/form-values/currency-price-form-values';
import { ProductDetailScalePrices } from './product-detail-scale-prices';
import { ProductDetailSpecialPrices } from './product-detail-special-prices';
import { bestLocaleSelector } from '../../../../../../common/selectors/locale-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginBottom: theme.spacing(6),
    },
}));

interface ProductDetailPricesCurrencyProps {
    currencyPrice: CurrencyPriceFormValues;
    index: number;
}

export const ProductDetailPricesCurrency = (props: ProductDetailPricesCurrencyProps) => {
    const { currency } = props.currencyPrice;
    const locale = useAppSelector(state => bestLocaleSelector(state));
    const classes = useStyles();

    return (
        <>
            <PoolTypography styleType="sectionTitle" id={`app.product.detail.prices.${currency}`} />
            <div className={classes.container}>
                <Grid container={true} spacing={2}>
                    <Grid item={true} xs={4}>
                        <Field name={`currencyPrices.${props.index}.mainPrice`}>
                            {({ field, meta }: FieldProps<number>) => (
                                <PoolTextField
                                    {...field}
                                    fullWidth={true}
                                    label={<FormattedMessage id="app.product.detail.prices.sellingPrice" />}
                                    isNumeric={true}
                                    noNegativeNumbers={true}
                                    suffix={getSuffixCurrency(field.value, currency, locale)}
                                    required={true}
                                    error={meta.touched && !!meta.error}
                                    helperText={
                                        meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null
                                    }
                                />
                            )}
                        </Field>
                    </Grid>
                </Grid>

                <ProductDetailSpecialPrices currency={currency} index={props.index} />
                <ProductDetailScalePrices currency={currency} index={props.index} />
            </div>
        </>
    );
};
